import { Reducer, WidgetState } from '../../../WidgetBlocks/types/IWidgetBlock';
import { TypeKeys, WidgetBlockAction } from './types';

type InitializeWidgetAction = WidgetBlockAction<TypeKeys.INITIALIZE_WIDGET, { reducer: Reducer<WidgetState> }>;

const initializeWidget = (widgetId: string, instanceId: string, reducer: Reducer<WidgetState>): InitializeWidgetAction => ({
    type: TypeKeys.INITIALIZE_WIDGET,
    payload: {
        widgetId,
        instanceId,
        reducer,
    },
});

export default initializeWidget;
export { InitializeWidgetAction };
